import { useState, useEffect, useCallback } from "preact/hooks";
import { copyToClipboard } from "../utils/clipboard";
import type { IUseCopyRow } from "../types";

export const useCopyRow = (): IUseCopyRow => {
    const [selectedRowId, setSelectedRowId] = useState<string | null>(null);
    const [rowData, setRowData] = useState<Record<string, string> | null>(null);

    const handleRowClick = useCallback((rowId: string, data: Record<string, string>) => {
        setSelectedRowId(rowId);
        setRowData(data);
    }, []);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if ((e.ctrlKey || e.metaKey) && (e.key === 'c' || e.key === 'с') && rowData !== null) {
                e.preventDefault();
                const values = Object.values(rowData);
                const textToCopy = values.join('\t');
                
                copyToClipboard(textToCopy);
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [rowData]);

    const getRowClass = useCallback((rowId: string) => {
        return selectedRowId === rowId
            ? 'bg-primary/20 border-t-2 border-b-2 border-l-2 border-r-2 border-primary'
            : '';
    }, [selectedRowId]);

    const clearSelection = useCallback(() => {
        setSelectedRowId(null);
        setRowData(null);
    }, []);

    return { 
        selectedRowId, 
        handleRowClick, 
        getRowClass,
        clearSelection
    };
};

